import React from 'react'
import Dashboard from '../features/home'
export default function Home() {
  return (
    <></>
  )
}
